module.exports = __webpack_public_path__ + "img/inverter.dd6fcf4e.svg";